import React from "react";
import { Box, Typography } from "@mui/material";
import DataGridSkeleton from "../PageSkeletons/DataGridSkeleton";

const DatagridLoading = ({
	message,
	actionButtons = 1,
	columns = 4,
	rows = 6,
	showTabs = false,
	tabCount = 0,
}) => {
	return (
		<Box sx={{ width: "100%", py: 1 }}>
			<DataGridSkeleton
				containerClassName=""
				showTabs={showTabs}
				tabCount={tabCount}
				actionButtons={actionButtons}
				columns={columns}
				rows={rows}
			/>
			{message && (
				<Typography
					variant="body2"
					color="text.secondary"
					align="center"
					sx={{ mt: 1 }}
				>
					{message}
				</Typography>
			)}
		</Box>
	);
};

export default DatagridLoading;
